<template>
  <div class="FAQtable">
    <accordion>
        <accordion-item>
          <!-- This slot will handle the title/header of the accordion and is the part you click on -->
          <template slot="accordion-trigger">
            <h5>{{ $t('faq1q') }}</h5>
          </template>
          <!-- This slot will handle all the content that is passed to the accordion -->
          <template slot="accordion-content">
            <ul>
              <li>{{ $t('clientReq1') }}</li>
              <li>{{ $t('clientReq2') }}</li>
              <li>{{ $t('clientReq3') }}</li>
            </ul>
            <br/>
            <InstructionsModal/>
          </template>
        </accordion-item>

        <!-- <accordion-item>
          <template slot="accordion-trigger">
            <h5>{{ $t('faq2q') }}</h5>
          </template>
          <template slot="accordion-content">
            <br/>
            <br/>
          </template>
        </accordion-item> -->

        <!-- <accordion-item>
          <template slot="accordion-trigger">
            <h5>{{ $t('faq3q') }}</h5>
          </template>
          <template slot="accordion-content">
            <br/>
            <br/>
          </template>
        </accordion-item> -->

      </accordion>
  </div>
</template>

<script>
import Accordion from "@/components/common/accordion";
import AccordionItem from "@/components/common/accordion-item";
import InstructionsModal from '@/components/onboarding/InstructionsModal.vue'


export default {
  components: {
    Accordion,
    AccordionItem,
    InstructionsModal
  }
};
</script>

<style lang="scss" scoped>
.FAQtable h5 {
  font-size: 1.8em;
  font-weight: 600;
  text-align: left;
}
.FAQtable ul {
  text-align: left;
}
.FAQtable {
  margin: 0% 20% 5% 6%;
}
.resp-container {
  position: relative;
  overflow: hidden;
  width: 100%;
  // max-width: 400px;
  // max-height: 100px;
  padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
}

/* Then style the iframe to fit in the container div with full height and width */
.resp-iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
.responsive {
  width: 100%;
  height: auto;
}
  .stripeLogo {
    max-width: 250px;
  }
@media screen and (max-width: 700px){
.FAQtable {
  margin: 3% 3% 10% 3%;
  text-align: left;
}
.FAQtable h5 {
  font-size: 1.3em;
  font-weight: 400;
}
}
</style>
